import NP_template from "./NP_template-xxxxx.json";
import NS_template from "./NS_template-yyyyyy.json";
import PR_template from "./PR_template.json";
import ST_template from "./ST_template.json";
import SO_template from "./SO_template.json";
// Medstudent variants — opt-in per type. usePatientDocument prefers MEDSTUDENT_* when present.
import MEDSTUDENT_NP_template from "./MEDSTUDENT_NP_template.json";

export const templates = {
  NP: NP_template,
  NS: NS_template,
  PR: PR_template,
  ST: ST_template,
  SO: SO_template,
  MEDSTUDENT_NP: MEDSTUDENT_NP_template,
};

// Default export for compatibility
export default templates;
